import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Eyebrow, SerifH } from "./shared";
import { PRODUCTS } from "../data/content";

function ProductCard({ p, i }) {
  return (
    <motion.article
      data-testid={`product-${p.slug}`}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className="group"
    >
      <Link to={`/product/${p.slug}`} data-testid={`product-link-${p.slug}`} className="block">
      <div className="relative overflow-hidden bg-[#F4EDE2] aspect-[558/1000]">
        <img
          src={p.image}
          alt={`${p.name} — ${p.print}`}
          loading="lazy"
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[900ms] ease-out ${
            p.hoverImage ? "group-hover:opacity-0" : ""
          }`}
        />
        {p.hoverImage && (
          <img
            src={p.hoverImage}
            alt={`${p.name} — back view`}
            loading="lazy"
            data-testid={`product-back-${p.slug}`}
            className="absolute inset-0 h-full w-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-[900ms] ease-out"
          />
        )}
        {p.tag === "NEW DROP" ? (
          <div
            data-testid={`tag-${p.slug}`}
            aria-label="New drop"
            className="pointer-events-none absolute top-0 left-0 z-10 overflow-hidden"
            style={{ width: 140, height: 140 }}
          >
            <div
              className="yaba-newdrop-ribbon absolute"
              style={{
                top: 26,
                left: -42,
                width: 180,
                transform: "rotate(-45deg)",
                background:
                  "linear-gradient(90deg, #C8A96A 0%, #E9CE95 50%, #C8A96A 100%)",
                color: "#0C111C",
                textAlign: "center",
                padding: "6px 0",
                fontSize: 10,
                letterSpacing: "0.28em",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                boxShadow: "0 4px 12px rgba(12,17,28,0.18)",
              }}
            >
              NEW DROP
            </div>
          </div>
        ) : p.tag && (
          <span
            data-testid={`tag-${p.slug}`}
            className={`absolute top-4 left-4 z-10 rounded-full px-3 py-1 text-[10px] tracking-[0.2em] uppercase ${
              p.tag === "NEW" ? "bg-[#C8A96A] text-[#0C111C]" : "bg-[#B95841] text-[#F4EDE2]"
            }`}
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            {p.tag}
          </span>
        )}
        <button
          data-testid={`quick-add-${p.slug}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
          className="absolute inset-x-4 bottom-4 z-10 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 rounded-full bg-[#0C111C] text-[#F4EDE2] py-3 text-sm font-medium hover:bg-[#C8A96A] hover:text-[#0C111C]"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Add to bag +
        </button>
      </div>
      <div className="mt-5 flex items-baseline justify-between">
        <div>
          <p className="text-lg" style={{ fontFamily: "Fraunces, serif" }}>
            {p.name}
          </p>
          <p className="text-sm text-[#4A3626]/80" style={{ fontFamily: "Inter, sans-serif" }}>
            {p.print}
          </p>
        </div>
        <p className="text-lg text-[#4A3626]" style={{ fontFamily: "Fraunces, serif" }}>
          {p.price}
        </p>
      </div>
      </Link>
    </motion.article>
  );
}

export function Collection() {
  return (
    <section id="the-collection" data-testid="collection" className="bg-[#F4EDE2] text-[#0C111C]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Eyebrow>The 2026 collection</Eyebrow>
            <SerifH className="mt-4" size="clamp(32px, 3.8vw, 60px)">
              Sixteen jellabas.
              <br className="hidden md:block" /> One quiet obsession.
            </SerifH>
          </div>
          <a
            href="#"
            data-testid="collection-see-all"
            className="inline-flex items-center gap-2 text-sm underline decoration-[#C8A96A] decoration-1 underline-offset-4 hover:text-[#B95841] transition-colors self-start md:self-end"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            See the full range <ArrowRight size={14} />
          </a>
        </div>
        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.slug} p={p} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
